import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    intervoiceInvites: {
      selectIds: [],
      filters: {},
      paginate: {},
      selectId: false
    }
  },
  mutations: {
    SET_INTERVIDEOINVITE_SELECT_IDS (store, ids) {
      store.intervoiceInvites.selectIds = ids
    },
    REMOVE_INTERVIDEOINVITE_SELECT_IDS (store, ids) {
      store.intervoiceInvites.selectIds = store.intervoiceInvites.selectIds.filter((v) => { return !ids.includes(v) })
    },
    SET_INTERVIDEOINVITE_SELECT_ID (store, id) {
      store.intervoiceInvites.selectId = id
    },
    SET_INTERVIDEOINVITE_FILTERS (store, filters) {
      store.intervoiceInvites.filters = filters
    },
    SET_INTERVIDEOINVITE_PAGINATE (store, val) {
      store.intervoiceInvites.paginate = {
        limit: val.limit,
        page: val.page,
        pages: val.pages,
        total: val.total
      }
    }
  },
  getters: {
    getIntervoiceInvites: (store, getters) => {
      return store.intervoiceInvites.selectIds.map((id) => {
        return getters['entities/intervoiceInvites/find'](id)
      })
    },
    getIntervoiceInvitesFilters: (store, getters) => {
      return store.intervoiceInvites.filters
    },
    getIntervoiceInvitesPaginate: (store, getters) => {
      return store.intervoiceInvites.paginate
    },
    getIntervoiceInvite: (store, getters) => {
      return getters['entities/intervoiceInvites/find'](store.intervoiceInvites.selectId) || {}
    }
  },
  actions: {
    /*
    selectIntervoiceInvites
    */
    selectIntervoiceInvites ({commit, dispatch, getters, state}, filters) {
      return dispatch('getIntervoiceInvites', filters)
      .then((response) => {
        commit('SET_INTERVIDEOINVITE_FILTERS', filters)
        commit('SET_INTERVIDEOINVITE_PAGINATE', response)
        commit('SET_INTERVIDEOINVITE_SELECT_IDS', response.docs.map((item) => { return item._id }))
        return response
      })
    },
    /*
    refreshSelectIntervoiceInvites
    */
    refreshSelectIntervoiceInvites ({commit, dispatch, getters, state}) {
      return dispatch('selectIntervoiceInvites', getters.getIntervoiceInvitesFilters)
    },
    /*
    selectIntervoiceInvite
    */
    selectIntervoiceInvite ({commit, dispatch, getters, state}, id) {
      return dispatch('getIntervoiceInviteById', id)
      .then((response) => {
        commit('SET_INTERVIDEOINVITE_SELECT_ID', response._id)
        return response
      })
    },
    /*
    getIntervoiceInvites
    */
    getIntervoiceInvites ({commit, dispatch, getters, state}, filters) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/intervoice-invites`, {params: filters})
      .then((response) => {
        return dispatch('entities/intervoiceInvites/insert', {
          data: response.data.docs
        })
        .then((result) => {
          return {
            docs: result.intervoiceInvites || [],
            limit: response.data.limit,
            page: response.data.page,
            pages: response.data.pages,
            total: response.data.total
          }
        })
      })
    },
    /*
    getIntervoiceInviteById
    */
    getIntervoiceInviteById ({commit, dispatch, getters, state}, id) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/intervoice-invites/${id}`)
      .then((response) => {
        return dispatch('entities/intervoiceInvites/insert', {
          data: response.data
        })
      })
      .then((result) => {
        return result.intervoiceInvites[0]
      })
    },
    /*
    createIntervoiceInvite
    */
    createIntervoiceInvite ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .post(`/accounts/${getters.getAccount._id}/intervoice-invites`, data)
      .then((response) => {
        return dispatch('entities/intervoiceInvites/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.intervoiceInvites[0]
      })
    },
    /*
    updateIntervoiceInvite
    */
    updateIntervoiceInvite ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${getters.getAccount._id}/intervoice-invites/${data._id}`, data)
      .then((response) => {
        return dispatch('entities/intervoiceInvites/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.intervoiceInvites[0]
      })
    },
    /*
    deleteIntervoiceInvite
    */
    deleteIntervoiceInvite ({commit, dispatch, getters, state}, id) {
      return axios
      .delete(`/accounts/${getters.getAccount._id}/intervoice-invites/${id}`)
      .then((response) => {
        commit('REMOVE_INTERVIDEOINVITE_SELECT_IDS', [id])
        dispatch('entities/intervoiceInvites/delete', id)
        return {}
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/IntervoiceInvite.js